import { render, staticRenderFns } from "./AlertMessage.vue?vue&type=template&id=bbea898a&scoped=true"
import script from "./AlertMessage.vue?vue&type=script&lang=js"
export * from "./AlertMessage.vue?vue&type=script&lang=js"
import style0 from "./AlertMessage.vue?vue&type=style&index=0&id=bbea898a&prod&lang=scss"
import style1 from "./AlertMessage.vue?vue&type=style&index=1&id=bbea898a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbea898a",
  null
  
)

export default component.exports